import '../../Rating.scss';

import { Radio, Row } from 'antd';

import { Text } from 'components/mvp-typography';
import HappyFace from 'img/happyface.svg';
import UnhappyFace from 'img/unhappyface.svg';
import { RatingPropsNew } from '../../types';
import { MinMaxRadioButtons } from '../min-max-radio-buttons';

interface ButtonRatingProps extends RatingPropsNew {
  itemHighlight?: Record<any, any>;
}

export function ButtonRating(props: ButtonRatingProps) {
  const {
    min = 1,
    max = 99,
    beforeIcon = <img src={UnhappyFace} />,
    afterIcon = <img src={HappyFace} />,
    beforeLabel = 'Unable',
    afterLabel = 'Able',
  } = props;

  const classRow = props.disabled
    ? 'crx-circular-rating-disabled'
    : 'crx-circular-rating-active';

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }} className={classRow}>
      <Radio.Group
        size="large"
        value={props.value}
        disabled={props.disabled}
        onChange={e => props.onChange?.(e.target.value)}
      >
        <Row align="middle" justify="center">
          {props.iconsForward ? beforeIcon : afterIcon}

          {beforeLabel && (
            <Text style={{ marginLeft: 20, marginRight: 20 }}>
              {beforeLabel}
            </Text>
          )}
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '30px',
              alignItems: 'center'
            }}
          >
            <MinMaxRadioButtons
              disabled={!!props.disabled}
              min={min}
              max={max}
              colorsForward={props.colorsForward}
            />
          </div>
          {afterLabel && (
            <Text style={{ marginLeft: 20, marginRight: 20 }}>
              {afterLabel}
            </Text>
          )}
          {props.iconsForward ? afterIcon : beforeIcon}
        </Row>
      </Radio.Group>
    </div>
  );
}
